// Tipos de ingresos
export const TIPOS_INGRESO = [
  { value: 'CUOTA_MANTENIMIENTO', label: 'Cuota Mantenimiento' },
  { value: 'MORA', label: 'Mora' },
  { value: 'ALQUILER', label: 'Alquiler' },
  { value: 'EXTRAORDINARIO', label: 'Extraordinario' },
  { value: 'ADELANTADO', label: 'Adelantado' },
  { value: 'OTROS', label: 'Otros' }
];

// Categorías de egresos (según formato de balance)
export const CATEGORIAS_EGRESO = [
  { value: 'PERSONAL', label: 'Personal' },
  { value: 'GASTO_FIJO', label: 'Gasto Fijo' },
  { value: 'GASTO_VARIABLE', label: 'Gasto Variable' }
];

// Subcategorías de egresos
export const SUBCATEGORIAS_EGRESO = {
  PERSONAL: [
    { value: 'SUELDO', label: 'Sueldo' },
    { value: 'BONIFICACION', label: 'Bonificación' },
    { value: 'ONP', label: 'ONP' },
    { value: 'AFP', label: 'AFP' },
    { value: 'ESSALUD', label: 'Essalud' },
    { value: 'SEGURO', label: 'Seguro' },
    { value: 'REEMBOLSO', label: 'Reembolso' },
    { value: 'OTRO', label: 'Otro' }
  ],
  GASTO_FIJO: [
    { value: 'ADMINISTRACION', label: 'Administración' },
    { value: 'AGUA', label: 'Agua (Sedapal)' },
    { value: 'LUZ', label: 'Luz (Luz del Sur)' },
    { value: 'ASCENSOR', label: 'Mantenimiento Ascensor' },
    { value: 'CONTADOR', label: 'Contador' },
    { value: 'TELEFONO', label: 'Teléfono/Celular' },
    { value: 'INTERNET', label: 'Internet' },
    { value: 'SEGURO_EDIFICIO', label: 'Seguro del Edificio' },
    { value: 'OTRO', label: 'Otro' }
  ],
  GASTO_VARIABLE: [
    { value: 'REPARACION', label: 'Reparación' },
    { value: 'LIMPIEZA', label: 'Limpieza' },
    { value: 'FUMIGACION', label: 'Fumigación' },
    { value: 'POZO_SEPTICO', label: 'Limpieza Pozo Séptico' },
    { value: 'COPIAS', label: 'Copias e Impresiones' },
    { value: 'IMPUESTO_CREDITO', label: 'Impuesto a los Créditos' },
    { value: 'IMPUESTO_DEBITO', label: 'Impuesto a los Débitos' },
    { value: 'MATERIALES', label: 'Materiales' },
    { value: 'OTRO', label: 'Otro' }
  ]
};

// Estados de departamento
export const ESTADOS_DEPARTAMENTO = [
  { value: 'ACTIVO', label: 'Al día' },
  { value: 'MOROSO', label: 'Moroso' },
  { value: 'INACTIVO', label: 'Inactivo' }
];

// Tipos de departamento
export const TIPOS_DEPARTAMENTO = [
  { value: 'DEPARTAMENTO', label: 'Departamento' },
  { value: 'LOCAL_COMERCIAL', label: 'Local Comercial' },
  { value: 'OFICINA', label: 'Oficina' },
  { value: 'COCHERA', label: 'Cochera' }
];

// Tipos de proveedor
export const TIPOS_PROVEEDOR = [
  { value: 'SERVICIOS', label: 'Servicios' },
  { value: 'MANTENIMIENTO', label: 'Mantenimiento' },
  { value: 'LIMPIEZA', label: 'Limpieza' },
  { value: 'SEGURIDAD', label: 'Seguridad' },
  { value: 'OTROS', label: 'Otros' }
];

// Cargos de personal
export const CARGOS_PERSONAL = [
  { value: 'ADMINISTRADOR', label: 'Administrador' },
  { value: 'PORTERO', label: 'Portero' },
  { value: 'LIMPIEZA', label: 'Limpieza' },
  { value: 'VIGILANTE', label: 'Vigilante' },
  { value: 'MANTENIMIENTO', label: 'Mantenimiento' }
];

// Categorías de equipos
export const CATEGORIAS_EQUIPO = [
  { value: 'ASCENSORES', label: 'Ascensores' },
  { value: 'SISTEMA_HIDRAULICO', label: 'Sistema Hidráulico' },
  { value: 'SISTEMA_ELECTRICO', label: 'Sistema Eléctrico' },
  { value: 'SEGURIDAD', label: 'Seguridad' },
  { value: 'ACCESOS', label: 'Accesos' },
  { value: 'ILUMINACION', label: 'Iluminación' },
  { value: 'LIMPIEZA', label: 'Limpieza' },
  { value: 'MOBILIARIO', label: 'Mobiliario' },
  { value: 'ELECTRONICO', label: 'Electrónico' }
];

// Estados de equipos
export const ESTADOS_EQUIPO = [
  { value: 'OPERATIVO', label: 'Operativo' },
  { value: 'EN_REPARACION', label: 'En Reparación' },
  { value: 'FUERA_DE_SERVICIO', label: 'Fuera de Servicio' },
  { value: 'DADO_DE_BAJA', label: 'Dado de Baja' }
];

// Tipos de comunicado
export const TIPOS_COMUNICADO = [
  { value: 'AVISO', label: 'Aviso' },
  { value: 'CONVOCATORIA', label: 'Convocatoria' },
  { value: 'INFORMATIVO', label: 'Informativo' },
  { value: 'SOCIAL', label: 'Social' },
  { value: 'URGENTE', label: 'Urgente' }
];

// Prioridades
export const PRIORIDADES = [
  { value: 'ALTA', label: 'Alta' },
  { value: 'MEDIA', label: 'Media' },
  { value: 'BAJA', label: 'Baja' }
];

// Tipos de incidencia
export const TIPOS_INCIDENCIA = [
  { value: 'RECLAMO', label: 'Reclamo' },
  { value: 'SUGERENCIA', label: 'Sugerencia' },
  { value: 'MANTENIMIENTO', label: 'Mantenimiento' },
  { value: 'SEGURIDAD', label: 'Seguridad' },
  { value: 'RUIDO', label: 'Ruido' },
  { value: 'OTROS', label: 'Otros' }
];

// Estados de incidencia
export const ESTADOS_INCIDENCIA = [
  { value: 'PENDIENTE', label: 'Pendiente' },
  { value: 'EN_PROCESO', label: 'En Proceso' },
  { value: 'RESUELTO', label: 'Resuelto' },
  { value: 'CERRADO', label: 'Cerrado' }
];

// Tipos de entrega
export const TIPOS_ENTREGA = [
  { value: 'PAQUETE', label: 'Paquete' },
  { value: 'CORRESPONDENCIA', label: 'Correspondencia' },
  { value: 'DELIVERY', label: 'Delivery' },
  { value: 'DOCUMENTO', label: 'Documento' },
  { value: 'OTROS', label: 'Otros' }
];

// Categorías de documentos
export const CATEGORIAS_DOCUMENTO = [
  { value: 'REGLAMENTOS', label: 'Reglamentos' },
  { value: 'ACTAS', label: 'Actas' },
  { value: 'FINANCIERO', label: 'Financiero' },
  { value: 'SEGURIDAD', label: 'Seguridad' },
  { value: 'CONTRATOS', label: 'Contratos' },
  { value: 'OTROS', label: 'Otros' }
];

// Roles de usuario
export const ROLES = [
  { value: 'ADMIN', label: 'Administrador' },
  { value: 'PRESIDENTE', label: 'Presidente' },
  { value: 'TESORERO', label: 'Tesorero' },
  { value: 'SECRETARIO', label: 'Secretario' },
  { value: 'PROPIETARIO', label: 'Propietario' },
  { value: 'PORTERO', label: 'Portero' }
];

// Meses
export const MESES = [
  { value: 1, label: 'Enero' },
  { value: 2, label: 'Febrero' },
  { value: 3, label: 'Marzo' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Mayo' },
  { value: 6, label: 'Junio' },
  { value: 7, label: 'Julio' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Septiembre' },
  { value: 10, label: 'Octubre' },
  { value: 11, label: 'Noviembre' },
  { value: 12, label: 'Diciembre' }
];

// Tipos de sanción
export const TIPOS_SANCION = [
  { value: 'MOROSIDAD', label: 'Morosidad' },
  { value: 'RUIDO', label: 'Ruido Excesivo' },
  { value: 'MASCOTAS', label: 'Mascotas' },
  { value: 'AREAS_COMUNES', label: 'Mal uso de Áreas Comunes' },
  { value: 'ESTACIONAMIENTO', label: 'Estacionamiento' },
  { value: 'BASURA', label: 'Manejo de Basura' },
  { value: 'MODIFICACIONES', label: 'Modificaciones No Autorizadas' },
  { value: 'CONDUCTA', label: 'Mala Conducta' },
  { value: 'OTRO', label: 'Otro' }
];

// Estados de sanción
export const ESTADOS_SANCION = [
  { value: 'PENDIENTE', label: 'Pendiente' },
  { value: 'PAGADA', label: 'Pagada' },
  { value: 'APELADA', label: 'Apelada' },
  { value: 'ANULADA', label: 'Anulada' }
];
